// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__qfRcY","light":"Button_light__opChS","white":"Button_white__gXmy+","dark":"Button_dark__qwSZs"};